import { showRevenueModal } from "@actions/modals";
import { getCategories } from "@api/egm";
import revenue from "@api/revenue";
import BaseRevenueView from "@components/revenue/BaseRevenueView";
import { handleDownload } from "@helpers/downloads";
import { connect } from "react-redux";

class IncomeSecurityView extends BaseRevenueView {
  useGroupBy = true;
  isVariance = true;
  fnGetViewTypes = revenue.getIncomeSecurityViewTypes;
  fnGetGraphOptions = revenue.getIncomeGraphOptions;

  handleApiCall = (fnRequest, fnSuccess, fnFailure) => {
    const {
      selectedOperator,
      selectedWeek,
      selectedVarianceType,
      selectedCategory,
      selectedViewType,
      selectedGroupBy,
      selectedRegion,
    } = this.state;
    fnRequest(
      selectedOperator,
      selectedWeek,
      selectedCategory,
      selectedViewType,
      selectedVarianceType,
      selectedGroupBy,
      selectedRegion,
    ).then(
      (summary) => fnSuccess(summary),
      () => fnFailure(),
    );
  };

  handleRefresh = () => {
    this.setState(
      {
        activeRow: { optionShowDetails: false },
        graph: { lines: [], data: [] },
        loading: true,
      },
      () => {
        this.handleApiCall(
          revenue.getIncomeSummary,
          (summary) => this.setState({ summary, loading: false }),
          () => this.setState({ loading: false }),
        );
      },
    );
  };

  onExportClick = () => {
    this.setState({ exportLoading: true }, () => {
      this.handleApiCall(
        revenue.getIncomeSummaryExport,
        (response) =>
          this.setState({ exportLoading: false }, () =>
            handleDownload(response),
          ),
        () => this.setState({ exportLoading: false }),
      );
    });
  };

  onDetailsClick = () => {
    const { activeRow, selectedOperator, selectedVarianceType } = this.state;
    this.props.showRevenueModal(
      activeRow,
      selectedOperator,
      this.isVariance,
      () => this.handleRefresh(),
      selectedVarianceType,
    );
  };

  handleOperatorChange = (selectedOperator) => {
    this.setState({ selectedOperator, selectedCategory: -1 }, () => {
      revenue
        .getRegions(selectedOperator)
        .then((regions) => this.setState({ regions }));
      getCategories(selectedOperator).then((categories) =>
        this.setState({ categories }),
      );
    });
  };

  refreshGraph = () => {
    const {
      selectedWeek,
      selectedCategory,
      selectedGroupBy,
      selectedRegion,
      selectedViewType,
      selectedVarianceType,
      activeRow,
    } = this.state;
    this.setState({ chartLoading: true }, () => {
      revenue
        .getIncomeGraph(
          activeRow.siteId,
          selectedWeek,
          selectedCategory,
          selectedViewType,
          selectedVarianceType,
          selectedGroupBy,
          selectedRegion,
        )
        .then(
          (graph) => this.setState({ graph, chartLoading: false }),
          () => this.setState({ chartLoading: false }),
        );
    });
  };
}

const mapStateToProps = (state) => {
  return {
    operators: state.operators.filter((x) => x.value !== -1),
  };
};

export default connect(mapStateToProps, { showRevenueModal })(
  IncomeSecurityView,
);
